import * as React from "react";
const SvgFiRrManHead = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-man-head_svg__a)">
      <path
        fill="#062147"
        d="M14.5 13a1.499 1.499 0 1 1 0-2.998 1.499 1.499 0 0 1 0 2.998m7.351-4.726A9.975 9.975 0 0 0 12.001 0C5.1 0 3.123 4.674 1.818 7.767A6.4 6.4 0 0 1 .5 10.136a1 1 0 0 0 .38 1.856 15.8 15.8 0 0 0 7.256-1.1 1.5 1.5 0 1 0 1.724-.84 15.1 15.1 0 0 0 4.956-4.467 1 1 0 1 0-1.626-1.162A13.36 13.36 0 0 1 3 10.027c.227-.453.438-.956.662-1.483C4.892 5.628 6.423 2 12 2a7.98 7.98 0 0 1 7.954 7.15 1 1 0 0 0 .816.878A1.5 1.5 0 0 1 20.5 13a1.6 1.6 0 0 1-.252-.027.994.994 0 0 0-1.117.651C18.215 16.221 15.132 19 12.001 19c-2.9 0-5.6-2.283-6.767-4.539a1 1 0 0 0-1.776.92A11.26 11.26 0 0 0 8 19.953V23a1 1 0 1 0 2 0v-2.262c1.31.352 2.69.352 4 0V23a1 1 0 0 0 2 0v-3.046a11.04 11.04 0 0 0 4.732-4.962 3.5 3.5 0 0 0 1.12-6.718"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-man-head_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrManHead;
